import {defineStore} from "pinia";
import {Credit} from "@/core/interfaces/Credit";
import {creditApi} from "@/container";

export const useCreditStore = defineStore('credit', {
    state: () => ({
        credit: null as Credit | null,
        /** When the credit was last asked for, the answer may still be on its way. Reset on failure. */
        requestedAt: null as number | null
    }),
    actions: {
        refresh() {
            this.requestedAt = Date.now();

            creditApi().read()
                .then(response => this.credit = response)
                .catch(error => {
                    this.requestedAt = null;
                    throw error;
                });
        }
    },
    getters: {
        /**
         * Get the formatted balance as string.
         */
        formattedBalance(): string | null {
            if(!this.credit) {
                return null;
            }

            const s = this.credit.balance > 1 ? 's' : '';
            return `${this.credit.balance} crédit${s}`;
        }
    }
});
